export default "__VITE_ASSET__C6$Xr2iI__"